import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  footerView: { alignSelf: 'stretch', borderBottomLeftRadius: 0, borderBottomRightRadius: 0, marginHorizontal: 0 },
  modalBackdrop: {
    backgroundColor: colors.overlay.backdrop,
    flex: 1,
    justifyContent: 'flex-end',
  },
  modalCloseButton: {
    padding: 10,
  },
  modalContent: {
    backgroundColor: colors.neutral.cotton,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
    minHeight: '50%',
  },
  modalHeaderContainer: {
    borderBottomColor: colors.neutral.mist,
    borderBottomWidth: 1,
  },
  modalHeaderRow: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});
export default styles;
